/**
 * @description
 * Objeto carpavisosterPK
 */

import { CarpAvisosTerPK } from "./carpavisosterPK.model";

export class CarpAvisosTer {
    public carpAvisosTerPK: CarpAvisosTerPK = new CarpAvisosTerPK();
    public actiu: boolean;
    public dataCanvi: Date;

    constructor() {}
  
}